import React, { useState, useEffect  } from 'react';
import { motion } from "framer-motion";
import ReactTooltip from 'react-tooltip';
import { urlFor, client } from "../../sanity_client/client";
import AppWrap from "../../Wrapper/AppWrap";
import "./Skills.scss";

const Skills = () => {

    const [ experiences, setExperiences ] = useState([]);
    const [ skills, setSkills ] = useState([]);

    useEffect(()=>{
        const experienceQuerry = '*[_type == "experiences"]'; 
        const skillsQuerry = '*[_type == "skills"]';

        client.fetch(experienceQuerry).then((data)=>{setExperiences(data)})
        client.fetch(skillsQuerry).then((data)=>{setSkills(data)})
    },[])

    // function sortyear(arr){
    //     let newarr = arr.forEach(function(value){value.year = Number(value.year)})
    //     return newarr.sort(function(a, b){return a.year - b.year})
    // }

    const sortedExperience =()=>{
        // convert year from string to integer
        const newArr = experiences.map((item)=>(
            {...item, year: Number(item.year)}
        ))
        // sort from latest year
        return newArr.sort(function(a, b){return b.year - a.year})
        
    }


    return (
        <div className="skills-section">
            <h2 className="head-text">Skills & experience</h2>
            <div className="app__skills-container">
                <div className="app__skills-list">
                    {skills.map((sk) =>(
                        <motion.div key={sk._id} className="app__skills-item"
                            whileInView={{
                                opacity:[0,1],
                                x:[100, 0],
                                scale:[0.5,1],
                                transition:{duration: 0.3, type: "spring", stiffness: 100},
                                delay:0.5
                            }}
                        >
                            <div style={{backgroundColor: '#e9e9e9'}}>
                                <img src={urlFor(sk.icon)} alt={sk.name}/>
                            </div>
                            <p className="p-text">{sk.name}</p>
                        </motion.div>
                    ))}
                </div>

                <div className="app__skills-exp">
                    {sortedExperience().map((exp)=>(
                        <div className="app__skills-exp-item" key={exp._id}>
                            <div className="app__skills-exp-year">
                                <p className="bold-text">{exp.year}</p>
                            </div>
                            <div className="app__skills-exp-works">
                                {exp.works.map((wk)=>(
                                    <div key={wk._key + exp._id}>
                                        <motion.div className="app__skills-exp-work"
                                            whileInView={{opacity: [0,1]}}
                                            transition={{duration: 0.5}}
                                            key={wk._key}
                                            // stuff for tooltip to work
                                            data-tip
                                            data-for={wk._key}
                                        >
                                            <h4 className="bold-text">{wk.jobTitle}</h4>
                                            <p className="p-text">{wk.companyName}</p>
                                        </motion.div>
                                        <ReactTooltip
                                            key={wk._key + wk._type} 
                                            id = {wk._key}
                                            effect ="solid"
                                            // arrowColor='#fff'
                                            // className="skills-tooltip"
                                        >
                                            {wk.description}
                                        </ReactTooltip>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AppWrap(Skills, "skills")